<template>
  <div>
    <div class="header">
      <div class="back" @click="$emit('close')">
        <feather-icon icon="ArrowLeftIcon" size="24" />
        Trở về
      </div>
      <h3 class="mb-0">Chỉnh sửa trò chơi: {{ data.name }}</h3>
    </div>
    <div>
      <loading-button
        variant="primary"
        class="d-block ml-auto"
        @click="updateBetChoice"
        >Cập nhật</loading-button
      >
    </div>

    <b-tabs content-class="mt-3">
      <b-tab :title="betChoices.integration.title" active>
        <div class="text-center">Này và</div>
        <div class="d-flex">
          <div
            v-for="(choice, key) in integrationGroupClass2[0]"
            :key="key"
            class="d-flex w-25 flex-grow-1 border"
          >
            <div class="w-100 mx-2 my-1">
              <div class="d-flex justify mb-1">
                <div class="w-50">Số</div>
                <div class="w-50">Tỉ lệ</div>
              </div>
              <div class="d-flex">
                <b-form-group
                  label-cols="6"
                  content-cols="6"
                  :label="choice.class3_des"
                >
                  <b-form-input
                    type="number"
                    :value="choice.rate"
                    @change="(e) => onChangeBetChoiceRate(choice, e)"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex mt-2 flex-wrap">
          <div
            v-for="(choices, key) in integrationGroupClass2.slice(1)"
            :key="key"
            class="d-flex flex-grow-1 border"
            style="width: 20%"
          >
            <div class="w-100 mx-2 my-1">
              <div class="text-center text-capitalize mb-1">
                {{ choices[0].class2_des }}
              </div>
              <div
                v-for="(choiceInfo, choiceIdx) in choices"
                class="d-flex"
                :key="choiceIdx"
              >
                <b-form-group
                  label-cols="6"
                  content-cols="6"
                  :label="choiceInfo.class3_des"
                >
                  <b-form-input
                    type="number"
                    :value="choiceInfo.rate"
                    @change="(e) => onChangeBetChoiceRate(choiceInfo, e)"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
<!-- 
      <b-tab :title="betChoices['1st-10th'].title">
        <div class="d-flex mt-2 flex-wrap">
          <div
            v-for="(choices, key) in first10thGroupByClass2"
            :key="key"
            class="d-flex flex-grow-1 border"
            style="width: 20%"
          >
            <div class="w-100 mx-2 my-1">
              <div class="text-center text-capitalize mb-1">
                {{ choices[0].class2_des }}
              </div>
              <div class="d-flex justify mb-1">
                <div class="w-50">Số</div>
                <div class="w-50">Tỉ lệ</div>
              </div>
              <div
                v-for="(choiceInfo, choiceIdx) in choices"
                class="d-flex"
                :key="choiceIdx"
              >
                <b-form-group
                  label-cols="6"
                  content-cols="6"
                  :label="choiceInfo.class3_des"
                >
                  <b-form-input
                    type="number"
                    :value="choiceInfo.rate"
                    @change="(e) => onChangeBetChoiceRate(choiceInfo, e)"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </b-tab> -->

      <b-tab
        v-for="(tab, tabIndex) in tabsShow"
        :key="tabIndex"
        :title="betChoices[tab.key].title"
      >
        <div class="d-flex mt-2 flex-wrap">
          <div
            v-for="(choices, key) in tab.tabContent"
            :key="key"
            class="d-flex flex-grow-1 border"
            style="width: 20%"
          >
            <div class="w-100 mx-2 my-1">
              <div class="text-center text-capitalize mb-1">
                {{ choices[0].class2_des }}
              </div>
              <div class="d-flex justify mb-1">
                <div class="w-50">Số</div>
                <div class="w-50">Tỉ lệ</div>
              </div>
              <div
                v-for="(choiceInfo, choiceIdx) in choices"
                :key="choiceIdx"
              >
                <div
                  v-for="(subInfo, subIdx) in choiceInfo"
                  class="d-flex"
                  :key="subIdx"
                >
                  <b-form-group
                    label-cols="6"
                    content-cols="6"
                    :label="subInfo.class3_des"
                  >
                    <b-form-input
                      type="number"
                      :value="subInfo.rate"
                      @change="(e) => onChangeBetChoiceRate(subInfo, e)"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import { BFormGroup, BFormInput, BCard, BTabs, BTab } from "bootstrap-vue";
import LoadingButton from "@core/components/loading-button/LoadingButton.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import API from "@/api";

export default {
  components: { BFormGroup, BFormInput, BCard, BTabs, BTab, LoadingButton },
  props: {
    data: { type: Object },
  },

  data() {
    return {
      betChoices: {},
      submitBetChoicesData: [],
    };
  },

  computed: {
    integrationGroupClass2() {
      const values = this.groupBy(
        this.betChoices["integration"].values,
        "class2"
      );
      return Object.values(values);
    },

    // first10thGroupByClass2() {
    //   return this.groupByClass2("1st-10th");
    // },

    // tabsShow() {
    //   // ["1st-10th", "CrownSum", "CrownCombination"],
    //   return [
    //     {
    //       key: "CrownSum",
    //       tabContent: this.paginate(this.betChoices["CrownSum"].values, 5),
    //     },
    //     {
    //       key: "CrownCombination",
    //       tabContent: this.paginate(
    //         this.betChoices["CrownCombination"].values,
    //         9
    //       ),
    //     },
    //   ];
    // },
  },

  methods: {
    groupBy(arr, key) {
      const x = arr.reduce((prev, curr) => {
        prev[curr[key]] = prev[curr[key]] ?? [];
        prev[curr[key]].push(curr);
        return prev;
      }, {});
      return x;
    },

    groupByClass2(key) {
      return this.groupBy(this.betChoices[key].values, "class2");
    },

    paginate(arr, size) {
      const result = [];
      const num = Math.ceil(arr.length / size);
      for (let i = 0; i < num; i++) {
        const startIndex = i * size;
        const endIndex = i * size + size;
        result.push([arr.slice(startIndex, endIndex)]);
      }
      return result;
    },

    ObjListValues(obj) {
      return Object.values(obj);
    },

    onChangeBetChoiceRate(choice, e) {
      const { _id } = choice;
      this.submitBetChoicesData.forEach((item) => {
        if (item.id == _id) {
          Object.assign(item, {
            rate: e,
            updated: true,
          });
        }
      });
    },

    updateBetChoice() {
      const updateData = this.submitBetChoicesData
        .filter((e) => e.updated)
        .map((e) => {
          return {
            id: e.id,
            rate: +e.rate,
          };
        });

      if (updateData.length) {
        // submit
        const data = {
          betOptions: updateData,
        };
        this.submitUpdate(data);
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Cập trò chơi dùng thành công.",
            icon: "CheckIcon",
            variant: "success",
          },
        });
      }
    },

    async submitUpdate(data) {
      try {
        const res = await this.$http.patch(
          API.PRODUCT_UPDATE + this.data._id,
          data
        );
        if (res.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Cập trò chơi dùng thành công.",
              icon: "CheckIcon",
              variant: "success",
            },
          });
          this.$emit("updated");
        } else {
          throw res;
        }
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.message || "Lỗi",
            icon: "XIcon",
            variant: "danger",
          },
        });
      }
    },
  },

  created() {
    this.betChoices = this.data.betOptions.reduce((prev, curr) => {
      prev[curr.name] = { values: curr.values, title: curr.title };
      return prev;
    }, {});
    const betChoicesTmp = [];
    this.data.betOptions.forEach((e) => {
      const choiceList = e.values.map((item) => {
        const { _id: id, rate } = item;
        return { id, rate, updated: false };
      });
      betChoicesTmp.push(...choiceList);
    });
    this.submitBetChoicesData = betChoicesTmp;
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
}
.back {
  cursor: pointer;
  display: inline;
  font-size: 18px;
  &:hover {
    opacity: 0.5;
  }
}
</style>
